import { createFileRoute } from "@tanstack/react-router";
import { DecisionesPage } from "@/components/decisiones/DecisionesPage";

export const Route = createFileRoute("/decisiones")({
  head: () => ({
    meta: [
      { title: "Decision Center — LicitaPro" },
      {
        name: "description",
        content: "Centro estratégico de decisiones: postular, revisar o descartar con razones IA.",
      },
      { property: "og:title", content: "Decision Center — LicitaPro" },
      { property: "og:description", content: "Operacionaliza las recomendaciones del copiloto." },
    ],
  }),
  component: DecisionesPage,
});
